"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationProps = exports.getCartPageCopy = exports.getWidgetCopy = void 0;
const errors_1 = require("../types/errors");
const UNAUTH_KEYS = {
    header: 'session_expired.modal.title',
    content: 'session_expired.modal.text',
    button: 'session_expired.modal.cta',
};
const getWidgetCopy = (error, status) => {
    if (status === 401)
        return UNAUTH_KEYS;
    const code = error.error_code || (error === null || error === void 0 ? void 0 : error.errorCode);
    switch (code) {
        case errors_1.ErrorCode.CART_BRANDSPLACE_LIMITATION_EXCEEDED:
            return {
                header: (error === null || error === void 0 ? void 0 : error.error_title) || (error === null || error === void 0 ? void 0 : error.errorTitle),
                content: (error === null || error === void 0 ? void 0 : error.error_description) || (error === null || error === void 0 ? void 0 : error.errorDescription),
            };
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_UNITS:
            return {
                header: 'errors.cart.full.modal.title',
                content: 'errors.cart.full.modal.text',
            };
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_CAMPAIGNS:
            return {
                header: 'errors.cart.maximum_sales.modal.title',
                content: 'errors.cart.maximum_sales.modal.text',
            };
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_ITEM_UNITS:
            return {
                header: 'errors.cart.maximum_product_units.modal.title',
                content: 'errors.cart.maximum_product_units.modal.text',
            };
        case errors_1.ErrorCode.INVALID_ITEM_ID:
        case errors_1.ErrorCode.INVALID_ITEM_QUANTITY:
            return {
                content: 'errors.general_retry.notification',
            };
        case errors_1.ErrorCode.CATALOG_ERROR:
        case errors_1.ErrorCode.RESERVATION_ERROR:
            return {
                header: 'errors.cart.product_not_added.modal.title',
                content: 'errors.cart.product_not_added.modal.text',
            };
        case errors_1.ErrorCode.CATALOG_ITEM_NOT_FOUND:
            return {
                header: 'errors.cart.product_not_available.modal.title',
                content: 'errors.cart.product_not_available.modal.text',
            };
        case errors_1.ErrorCode.RESERVATION_NOT_ENOUGH_STOCK_ERROR:
            return {
                header: 'errors.cart.product_sold_out.modal.title',
                content: 'errors.cart.product_sold_out.modal.text',
            };
        case errors_1.ErrorCode.LOYALTY_RENEWAL:
            return {
                header: 'loyalty.holder.renewal.modal.title',
                content: 'loyalty.holder.renewal.modal.text',
                button: 'loyalty.holder.renewal.modal.cta',
            };
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_CART_REOPEN_CAMPAIGNS:
            return {
                header: 'errors.cart.reopen_order.modal.title',
                content: 'errors.cart.reopen_order.modal.text',
                button: 'common.close',
            };
        case errors_1.ErrorCode.CART_MAX_UNIT_PER_MEMBER:
            return {
                header: 'errors.cart.maximum_units_user.modal.title',
                content: 'errors.cart.maximum_units_user.modal.text',
                button: 'common.close',
            };
        case errors_1.ErrorCode.CART_RULE_VBI_THIRD_PARTY:
        case errors_1.ErrorCode.CART_RULE_NON_VBI_THIRD_PARTY:
            return {
                header: 'errors.cart.vbi_third_party.modal.title',
                content: 'errors.cart.vbi_third_party.modal.text',
            };
        case errors_1.ErrorCode.RESERVATION_OVERFLOW_ERROR:
            return {
                header: 'errors.cart.high_demanded_product.modal.title',
                content: 'errors.cart.high_demanded_product.modal.text',
            };
        case errors_1.ErrorCode.CART_RULE_FLASH_THIRD_PARTY:
            return {
                header: 'errors.cart.commission.modal.title',
                content: 'errors.cart.commission.modal.text',
                button: 'errors.cart.commission.modal.button',
            };
        case errors_1.ErrorCode.CART_NATURE:
            return {
                header: 'modal.premium.incompatibility.title',
                content: 'modal.premium.incompatibility.text',
                button: 'common.close',
            };
        default:
            return {};
    }
};
exports.getWidgetCopy = getWidgetCopy;
const getCartPageCopy = (error, status) => {
    if (status === 401)
        return UNAUTH_KEYS;
    const code = error.error_code || error.errorCode;
    switch (code) {
        case errors_1.ErrorCode.CART_SAVE_ERROR:
            return {
                header: 'errors.something_failed.modal.title',
                content: 'errors.something_failed.modal.text',
            };
        case errors_1.ErrorCode.INVALID_ITEM_ID:
        case errors_1.ErrorCode.INVALID_ITEM_QUANTITY:
            return {
                content: 'errors.cart.product_not_added.notification',
            };
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_UNITS:
            return {
                content: 'errors.cart.full.notification',
            };
        case errors_1.ErrorCode.CART_MAX_UNIT_PER_MEMBER:
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_ITEM_UNITS:
            return {
                content: 'errors.cart.maximum_units_user.notification',
            };
        case errors_1.ErrorCode.CART_ITEM_RETRIEVAL_ERROR:
            return {
                header: 'errors.cart.products_in_cart.modal.title',
                content: 'errors.cart.products_in_cart.modal.text',
            };
        case errors_1.ErrorCode.RESERVATION_ERROR:
            return {
                content: 'errors.general_retry.notification',
            };
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_CART_REOPEN_CAMPAIGNS:
            return {
                header: 'errors.cart.reopen_order.modal.title',
                content: 'errors.cart.reopen_order.modal.text',
                button: 'common.close',
            };
        case errors_1.ErrorCode.RESERVATION_NOT_ENOUGH_STOCK_ERROR:
            return {
                content: 'errors.cart.product_not_available.notification',
            };
        case errors_1.ErrorCode.LOYALTY_RENEWAL:
            return {
                header: 'loyalty.holder.renewal.modal.title',
                content: 'loyalty.holder.renewal.modal.text',
                button: 'loyalty.holder.renewal.modal.cta',
            };
        case errors_1.ErrorCode.RESERVATION_OVERFLOW_ERROR:
            return {
                header: 'errors.cart.high_demanded_product.modal.title',
                content: 'errors.cart.high_demanded_product.modal.text',
            };
        case errors_1.ErrorCode.CART_NATURE:
            return {
                header: 'modal.premium.incompatibility.title',
                content: 'modal.premium.incompatibility.text',
                button: 'common.close',
            };
        default:
            return {};
    }
};
exports.getCartPageCopy = getCartPageCopy;
const getNotificationProps = (code) => {
    switch (code) {
        case errors_1.ErrorCode.INVALID_ITEM_ID:
        case errors_1.ErrorCode.INVALID_ITEM_QUANTITY:
        case errors_1.ErrorCode.RESERVATION_ERROR:
        case errors_1.ErrorCode.CART_MAX_UNIT_PER_MEMBER:
            return {
                duration: 'med',
                disableIcon: true,
                variant: 'error',
            };
        case errors_1.ErrorCode.RESERVATION_NOT_ENOUGH_STOCK_ERROR:
        case errors_1.ErrorCode.CART_LIMITATION_EXCEEDED_UNITS:
            return {
                duration: 'max',
                disableIcon: true,
                variant: 'error',
            };
        default:
            return {};
    }
};
exports.getNotificationProps = getNotificationProps;
